module.exports = __webpack_public_path__ + "static/media/background.59fcf1ec.jpg";